/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */
/**
 *
 *
 * @author Misha Kokoulin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.0.0
 */

import { Fragment } from 'react';

import get from 'lodash/get';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import PageNotFound from '../../pages/ErrorPage/PageNotFound';
import { IRootReducer } from '../../reducers/rootReducer';
import { ValueOf } from '../../types/globalTypes';
import { Access } from './constants/guard/accessGuardConstants';
import { AccessComponentKeyEnum, ConnectionSourceEnum } from './constants/guard/guardConstants';
import { makeSelectGuardComponents } from './selectors/guardSelector';
import { GuardType, IGuardConnectedProps } from './types/guardTypes';

const getConnectionSource = (accessKey: AccessComponentKeyEnum) =>
    get(Access[accessKey], 'connectionSource', []) as ValueOf<typeof ConnectionSourceEnum>;

const isConnectionSource = (accessKeys: AccessComponentKeyEnum) =>
    getConnectionSource(accessKeys).includes(ConnectionSourceEnum.route);

/**
 * Universal component that adds access
 * @param {GuardType} props - component props
 * @returns {<P>(WrappedComponent: React.ComponentType<P>, type: ValueOf<IAuthorizationEnum>) => any}
 */
function Guard(props: GuardType) {
    const isAllowed = props.components[props.accessKey];
    return isAllowed ? props.children : isConnectionSource(props.accessKey) ? <PageNotFound /> : <Fragment />;
}

const mapStateToProps = createStructuredSelector<IRootReducer, IGuardConnectedProps>({
    components: makeSelectGuardComponents(),
});

export default connect(mapStateToProps)(Guard);
